module.exports = __webpack_public_path__ + "img/北京办公室2.7cd671e3.jpg";